import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import CategoriesList from './CategoriesList';
import PostList from './PostList';
import Filter from '../../Tabs/Filter';
import getPostsByCategory from '../../../api/graphql/queries/getPostsByCategory';
import Modal from '../../Modal/Modal';
import AddSubCategoryForm from './AddSubCategoryForm';
import TagManager from './TagManager';
import slugify from '../../../utils/slugify';
import LoadIcon from '../../LoadIcon';
import postDeletePost from '../../../api/graphql/mutations/postDeletePost';

class PostListContainer extends Component {
  state = {
    filterText: '',
    posts: [],
    filteredPosts: [],
    isLoading: true,
    isModalOn: false,
    isTagManagerOn: false,
    subCategories: [],
    reusablePosts: [],
    totalPosts: 0,
  };

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.getPosts();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleModal = () => {
    const { isModalOn } = this.state;
    this.setState({ isModalOn: !isModalOn });
  };

  toggleTagManager = () => {
    const { isTagManagerOn } = this.state;
    this.setState({ isTagManagerOn: !isTagManagerOn });
  };

  reFetchCats = () => {
    this.toggleModal();
    // getPostsByType('section')
    //   .then(({ posts }) => {
    //     if (posts) {
    //       setPosts(posts);
    //     }
    //   })
    //   .catch(err => console.log(err));
  };

  getPosts = () => {
    const {
      match: { params },
    } = this.props;
    if (params.postCategory) {
      getPostsByCategory(params.postCategory === 'blank' ? '' : params.postCategory)
        .then((res) => {
          if (res) {
            const { posts } = res;

            if (posts && posts.length) {
              const subCategories = [...posts].filter(i => i.type === 'sub-section');
              let routePosts = [...posts].filter(i => i.type === 'route');
              let uncategorizedPosts = [...posts].filter(i => i.type === 'route');
              const reusablePosts = [...posts].filter(i => i.type === 'component' && i.postName);
              let postCount = 0;
              subCategories.forEach((subC) => {
                const sluggedPostName = slugify(subC.postName);
                const arr = routePosts.filter(p => p.postCategory.includes(sluggedPostName));
                if (this._isMounted) {
                  this.setState({
                    [`arr-${sluggedPostName}`]: arr,
                    [`arr-filtered-${sluggedPostName}`]: arr
                  });
                  postCount = postCount + arr.length;
                }
                uncategorizedPosts = uncategorizedPosts.filter(p => !p.postCategory.includes(sluggedPostName));
              });

              if (this._isMounted) {
                this.setState({
                  reusablePosts,
                  filteredPosts: uncategorizedPosts,
                  posts: routePosts,
                  subCategories,
                  isLoading: false,
                  totalPosts: postCount,
                });
              }
            } else {
              if (this._isMounted) {
                this.setState({
                  isLoading: false,
                });
              }
            }
          }
        })
        .catch(err => console.log(err, ' => getPostsByCategory'));
    }
  };

  handleClick = () => {
    console.log('Item clicked');
  };

  openModal = () => {
    this.setState({
      isModalOn: !this.state.isModalOn,
    });
  };

  updateSearch = (val) => {
    const { posts, subCategories } = this.state;
    const filteredPosts = posts.filter(post => (post.postDescription && post.postDescription.title && post.postDescription.title.en.toLowerCase().includes(val)) || (post.slugName && post.slugName.toLowerCase().includes(val)));
    this.setState({ filteredPosts });
    subCategories.forEach((subC) => {
      const sluggedPostName = slugify(subC.postName);
      const itemsSubcat = this.state[`arr-${sluggedPostName}`];
      const arr = itemsSubcat.filter(post => (post.postDescription && post.postDescription.title && post.postDescription.title.en.toLowerCase().includes(val)) || (post.slugName && post.slugName.toLowerCase().includes(val)));
      this.setState({ [`arr-filtered-${sluggedPostName}`]: arr });
    });
  };

  handleDelete = (slugName) => {
    const isConfirmed = window.confirm('Are you sure you want to delete the category?');
    if (isConfirmed) {
      postDeletePost({ slugName }).then((deletePostResultData) => {
        if (deletePostResultData.isDeleted) this.getPosts();
      });
    } else {
      // If not confirmed, do nothing
      console.log('Deletion canceled.');
    }
  };

  showPostList = (subcat) => {
    const { postCategory } = this.props;

    const {
      postName,
      slugName,
      link,
      posts,
    } = subcat;
    const itsLink = link ? link : `/cms/structure/${postCategory}/${slugify(postName)}/choose-layout`
    const itsPosts = posts ? posts : this.state[`arr-filtered-${slugify(postName)}`];

    const hasChildrenPost = !!itsPosts.length;

    const CANT_BE_DELETED = ['uncategorizedPosts', 'reusablemodule'];

    // alwaysVisible = posts.length < 20 do not hide.
    let alwaysShow = false;
    // if (itsPosts && itsPosts.length < 20) alwaysShow = true;
    return (
      <div key={slugName} className="mb-2">
        <div className="flex justify-between items-center rounded border p-2">
          <div className={`flex items-center ${hasChildrenPost ? 'cursor-pointer' : ''}`} onClick={() => this.setState({ [slugName]: !this.state[slugName]})}>
            <span className="pr-3 uppercase font-americaMonoBold text-sm">{(itsPosts && itsPosts.length > 0) ? `${!this.state[slugName] ? '▶' : '▼' }` : ''} {postName}</span>
            {(itsPosts && itsPosts.length > 0) &&
              <span className="bg-blue-dark font-americaMonoBold font-light p-1 px-3 rounded-full text-white text-xxs">{itsPosts ? itsPosts.length : 0}</span>
            }
            {
              (!hasChildrenPost && !CANT_BE_DELETED.includes(slugName)) && (
                <button
                  type="button"
                  onClick={() => {
                    this.handleDelete(slugName);
                  }}
                  className="cursor-pointer ml-2"
                >
                  <span className="font-icon icon-trash text-sm" />
                </button>
              )
            }
          </div>
          <div className="">
            <Link to={itsLink}>
              <button className="font-americaMonoBold bg-blue-darker font-bold text-white
                text-xs rounded uppercase flex items-center p-2"
                type="button"
                >
                Add New
                <span className="font-icon icon-add-button font-bold pl-3 text-base" />
              </button>
            </Link>
          </div>
        </div>
        {(((itsPosts && itsPosts.length > 0) && this.state[slugName]) || alwaysShow) &&
          <div className="mt-2">
            <PostList
              postCategory={postCategory}
              posts={itsPosts}
              updatePostsList={this.getPosts}
            />
          </div>
        }
      </div>
    )
  }

  render() {
    const {
      filterText, isModalOn, isTagManagerOn, filteredPosts, isLoading, subCategories, reusablePosts,
    } = this.state;
    const { handleCategoryChange, postCategory } = this.props;
    return (
      <div className="w-full bg-white">
        {!postCategory ? (
          <>
            <CategoriesList onCategoryChange={handleCategoryChange} postCategory={postCategory} />
          </>
        ) : (
          <>
            <div className="flex justify-end mb-3">
              <Filter updateSearch={this.updateSearch} searchText={filterText} />
              {postCategory !== 'blank' && (
                <>
                  <button
                    className="my-4 xxl1:my-1 ml-2 font-americaMonoBold text-xs px-4 rounded bg-blue-darker text-white uppercase flex items-center"
                    onClick={this.toggleTagManager}
                    type="button"
                  >
                    Manage Tags
                  </button>
                  <button
                    className="my-4 xxl1:my-1 ml-2 font-americaMonoBold text-xs px-4 rounded bg-blue-darker text-white uppercase flex items-center"
                    onClick={this.toggleModal}
                    type="button"
                  >
                    Add new SubCategory
                    <span className="font-icon icon-add-button text-white font-black pl-3 text-base" />
                  </button>
                </>
              )}
            </div>

            {!isLoading ? (
              <>
                {subCategories.map(this.showPostList)}
                {
                    this.showPostList({
                      slugName: "uncategorizedPosts",
                      postName: "uncategorized entries",
                      link: `/cms/structure/${postCategory}/choose-layout`,
                      posts: filteredPosts,
                    })
                }
                <div className="flex flex-row w-full justify-between border my-4" />
                {reusablePosts &&
                    this.showPostList({
                      slugName: "reusablemodule",
                      postName: "Reusable Components",
                      link: `/cms/structure/${postCategory}/ReusableComponent/choose-layout/ReusableComponent`,
                      posts: reusablePosts,
                    })
                }
                <div className="flex flex-row w-full justify-between p-2 rounded bg-blue-lightest">
                  <h3 className="font-americaMonoBold text-sm uppercase">Total entries {`${this.state.totalPosts}`}</h3>
                </div>
              </>
            ) : <LoadIcon />}
            {isModalOn && (
            <Modal handleClick={this.toggleModal} positionMiddle>
              <AddSubCategoryForm handleClick={this.toggleModal} reFetch={this.reFetchCats} postCategory={postCategory} />
            </Modal>
            )}
            {isTagManagerOn && (
            <Modal handleClick={this.toggleTagManager} positionMiddle>
              <TagManager />
            </Modal>
            )}
          </>
        )}
      </div>
    );
  }
}

PostListContainer.propTypes = {
  handleCategoryChange: PropTypes.func.isRequired,
  postCategory: PropTypes.string,
  match: PropTypes.shape().isRequired,
};

PostListContainer.defaultProps = {
  postCategory: '',
};

export default withRouter(PostListContainer);
